{
    const backToTopButton = document.querySelector("#bux-back-to-top");

    if (backToTopButton instanceof HTMLElement) {
        let lastScrollY = window.scrollY;

        window.addEventListener('scroll', function () {
            if (lastScrollY > window.scrollY) {
                setBackToTopStyling(backToTopButton);
            }
            lastScrollY = window.scrollY;
        });
    }

    function isAtBackToTopThreshold(threshold: number) {
        return (
            document.body.scrollTop > threshold ||
            document.documentElement.scrollTop > threshold
        );
    }

    function setBackToTopStyling(buxButton: HTMLElement) {
        const doubleWindowHeight = window.innerHeight * 2;
        const lastContentContainer = buxButton.previousElementSibling;

        let lastPaddingBottom;
        if (lastContentContainer) {
            lastPaddingBottom = globalThis
                .getComputedStyle(buxButton)
                .getPropertyValue("padding-bottom");
        }

        if (isAtBackToTopThreshold(doubleWindowHeight)) {
            buxButton.style.display = "flex";

            if (lastContentContainer instanceof HTMLElement) {
                lastContentContainer.style.paddingBottom = "100px";
            }
        } else {
            buxButton.style.display = "none";

            if (lastContentContainer instanceof HTMLElement && typeof lastPaddingBottom === 'string') {
                lastContentContainer.style.paddingBottom = lastPaddingBottom;
            }
        }
    }
}
